import React, { ReactNode, useMemo } from 'react';
import { LegacyContentProps } from './types';
import { LegacyResult, LegacyResultConfig } from '../../../LegacyResults/useAdminLegacyResults';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

const ConfigurableFields = ["holder", "result1", "result2", "result3", "result4", "result5"];


export const ResultsDisplay = (props: LegacyContentProps & { title: ReactNode, positionLabel: string }) => {
  const configs: LegacyResultConfig[] = props.block.content.config;
  const results: LegacyResult[] = props.block.content.results;

  const grouped = useMemo(() => {
    return configs.map(c => {
      const r = results.filter(r => r.kind === c.kind);
      r.sort((a,b) => ((a as any).position || 0) < ((b as any).position || 0) ? -1 : 1)
      return {
      config: c,
      results: r,
      }})
    .filter(x => !!x.results.length);
  }, [configs, results]);

  return (
    <>
      {grouped.map(g => (
        <div key={g.config.kind}>
          <Typography variant="h4" sx={{ marginTop: "1rem" }}>{g.config.title}</Typography>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ paddingLeft: 0, paddingTop: 0, paddingBottom: 0 }}>
                  <Typography variant="caption">{props.positionLabel}</Typography>
                </TableCell>

                {ConfigurableFields.map(f => (g.config.labels || {})[f]
                  ? <TableCell sx={{ paddingTop: 0, paddingBottom: 0 }}>
                      <Typography variant="caption">{(g.config.labels || {})[f]}</Typography>
                  </TableCell>
                  : null)}
              </TableRow>
            </TableHead>

            <TableBody>
              {g.results.map(r => (
                <TableRow key={r._id}>
                  <TableCell>
                    {r.position || "-"}
                  </TableCell>
                  {ConfigurableFields.map(f => (g.config.labels || {})[f]
                    ? <TableCell>
                        {(r as any)[f] || "-"}
                    </TableCell>
                    : null)}
                </TableRow>))}
            </TableBody>
          </Table>
        </div>
      ))}
    </>
  );
}
